// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_pW2Q2 {
  font: normal 14px/20px var( --fontFamily-primary );
  color: var( --color-base700 );
  overflow: auto;
}
.table_pW2Q2 .row_w8QR2 {
  border-right: 1px solid var( --color-base100 );
}
.table_pW2Q2 .headerGroup__TnWa {
  z-index: 1;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  border-left: 0px solid var( --color-base100 );
  border-right: 0px outset var( --color-brand600 );
  border-bottom: 1px solid var( --color-base100 );
  background-color: var( --color-white );
}
.table_pW2Q2 .headerCell_Pw5sJ {
  padding: var( --size-padSmall ) var( --size-padSmall ) var( --size-padSmall ) var( --size-padMedium );
  outline: none !important;
  overflow: hidden;
  font-weight: 600;
  white-space: nowrap;
  border-right: 1px solid var( --color-base100 );
  text-overflow: ellipsis;
  border-top-color: var( --color-base100 );
  border-left-color: var( --color-base100 );
  border-bottom-color: var( --color-base100 );
}
.table_pW2Q2 .headerCell_Pw5sJ:first-child {
  padding-left: var( --size-padLarge );
}
.table_pW2Q2 .headerCell_Pw5sJ.sortDesc_EWBpl {
  box-shadow: inset 0px -4px var( --color-brand500 );
}
.table_pW2Q2 .headerCell_Pw5sJ.sortAsc_xgFD_ {
  box-shadow: inset 0px 4px var( --color-brand500 );
}
.table_pW2Q2 .bodyCell_puyVu {
  font: normal 14px/var( --size-pad12 ) Inter;
  color: #394756;
  padding: var( --size-padMedium ) var( --size-padSmall ) var( --size-padMedium ) var( --size-padMedium );
  border-right: 1px solid var( --color-base100 );
  border-bottom: 0.5px inset var( --color-base100 );
  border-top-color: var( --color-base100 );
  border-left-color: var( --color-base100 );
}
.table_pW2Q2 .bodyCell_puyVu:last-child {
  border-right: none;
}
.table_pW2Q2 .bodyCell_puyVu:first-child {
  border-left: none;
  padding-left: var( --size-padLarge );
}
.table_pW2Q2.table-dataTable_IWFjG {
  background-color: var( --color-base050 );
}
.table_pW2Q2.table-dataTable_IWFjG .row_w8QR2 {
  background-color: var( --color-white );
}
.table_pW2Q2.table-dataTable_IWFjG .headerGroup__TnWa {
  border-top: 1px solid var( --color-base100 );
}
.table_pW2Q2.table-dataTable_IWFjG .headerCell_Pw5sJ {
  padding: 0px;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_pW2Q2.table-dataTable_IWFjG .headerCell_Pw5sJ.sortDesc_EWBpl {
  box-shadow: inset 0px -2px var( --color-brand500 );
}
.table_pW2Q2.table-dataTable_IWFjG .headerCell_Pw5sJ.sortAsc_xgFD_ {
  box-shadow: inset 0px 2px var( --color-brand500 );
}
.table_pW2Q2.table-dataTable_IWFjG .row_w8QR2.odd_M1siB {
  background-color: var( --color-base025 );
}
.table_pW2Q2.table-dataTable_IWFjG .bodyCell_puyVu {
  padding: 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_pW2Q2.table-dataTable_IWFjG .bodyCell_puyVu:last-child {
  padding-right: 0px;
}
.table_pW2Q2.table-dataTable_IWFjG .bodyCell_puyVu:first-child {
  padding-left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/theme/TableV2.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,yCAAyC;EACzC,6CAA6C;EAC7C,gDAAgD;EAChD,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,qGAAqG;EACrG,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kDAAkD;AACpD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,2CAA2C;EAC3C,cAAc;EACd,uGAAuG;EACvG,8CAA8C;EAC9C,iDAAiD;EACjD,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".table {\n  font: normal 14px/20px var( --fontFamily-primary );\n  color: var( --color-base700 );\n  overflow: auto;\n}\n.table .row {\n  border-right: 1px solid var( --color-base100 );\n}\n.table .headerGroup {\n  z-index: 1;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n  border-left: 0px solid var( --color-base100 );\n  border-right: 0px outset var( --color-brand600 );\n  border-bottom: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n}\n.table .headerCell {\n  padding: var( --size-padSmall ) var( --size-padSmall ) var( --size-padSmall ) var( --size-padMedium );\n  outline: none !important;\n  overflow: hidden;\n  font-weight: 600;\n  white-space: nowrap;\n  border-right: 1px solid var( --color-base100 );\n  text-overflow: ellipsis;\n  border-top-color: var( --color-base100 );\n  border-left-color: var( --color-base100 );\n  border-bottom-color: var( --color-base100 );\n}\n.table .headerCell:first-child {\n  padding-left: var( --size-padLarge );\n}\n.table .headerCell.sortDesc {\n  box-shadow: inset 0px -4px var( --color-brand500 );\n}\n.table .headerCell.sortAsc {\n  box-shadow: inset 0px 4px var( --color-brand500 );\n}\n.table .bodyCell {\n  font: normal 14px/var( --size-pad12 ) Inter;\n  color: #394756;\n  padding: var( --size-padMedium ) var( --size-padSmall ) var( --size-padMedium ) var( --size-padMedium );\n  border-right: 1px solid var( --color-base100 );\n  border-bottom: 0.5px inset var( --color-base100 );\n  border-top-color: var( --color-base100 );\n  border-left-color: var( --color-base100 );\n}\n.table .bodyCell:last-child {\n  border-right: none;\n}\n.table .bodyCell:first-child {\n  border-left: none;\n  padding-left: var( --size-padLarge );\n}\n.table.table-dataTable {\n  background-color: var( --color-base050 );\n}\n.table.table-dataTable .row {\n  background-color: var( --color-white );\n}\n.table.table-dataTable .headerGroup {\n  border-top: 1px solid var( --color-base100 );\n}\n.table.table-dataTable .headerCell {\n  padding: 0px;\n  overflow: hidden;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.table.table-dataTable .headerCell.sortDesc {\n  box-shadow: inset 0px -2px var( --color-brand500 );\n}\n.table.table-dataTable .headerCell.sortAsc {\n  box-shadow: inset 0px 2px var( --color-brand500 );\n}\n.table.table-dataTable .row.odd {\n  background-color: var( --color-base025 );\n}\n.table.table-dataTable .bodyCell {\n  padding: 0px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.table.table-dataTable .bodyCell:last-child {\n  padding-right: 0px;\n}\n.table.table-dataTable .bodyCell:first-child {\n  padding-left: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_pW2Q2`,
	"row": `row_w8QR2`,
	"headerGroup": `headerGroup__TnWa`,
	"headerCell": `headerCell_Pw5sJ`,
	"sortDesc": `sortDesc_EWBpl`,
	"sortAsc": `sortAsc_xgFD_`,
	"bodyCell": `bodyCell_puyVu`,
	"table-dataTable": `table-dataTable_IWFjG`,
	"odd": `odd_M1siB`
};
export default ___CSS_LOADER_EXPORT___;
